// Display projection of MascotSleep.php. The server owns the saved energy.
export const SLEEP_DAY_MINUTES = 30
export const SLEEP_NIGHT_MINUTES = 360
const sleepClock = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'America/Sao_Paulo',
  hourCycle: 'h23',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
})

function sleepWindow(at: number) {
  const parts = sleepClock.formatToParts(new Date(at * 1000))
  const part = (type: string) => Number(parts.find((item) => item.type === type)?.value)
  const localSeconds =
    part('hour') * 3600 + part('minute') * 60 + part('second') + (((at % 1) + 1) % 1)
  const daytime = localSeconds >= 8 * 3600 && localSeconds < 20 * 3600
  const boundary = localSeconds < 8 * 3600 ? 8 * 3600 : daytime ? 20 * 3600 : 32 * 3600
  return {
    remaining: boundary - localSeconds,
    rate: 100 / ((daytime ? SLEEP_DAY_MINUTES : SLEEP_NIGHT_MINUTES) * 60),
  }
}

export function sleepingEnergy(energy: number, from: number, to: number) {
  while (from < to && energy < 100) {
    const window = sleepWindow(from)
    const seconds = Math.min(to - from, window.remaining)
    energy += seconds * window.rate
    from += seconds
  }
  return energy >= 100 - 1e-9 ? 100 : energy
}

/** Includes any 08:00/20:00 transition before the remaining energy is recovered. */
export function sleepSecondsUntilFull(energy: number, now: number) {
  let needed = Math.max(0, 100 - energy)
  let elapsed = 0
  while (needed > 1e-9) {
    const window = sleepWindow(now + elapsed)
    const seconds = Math.min(window.remaining, needed / window.rate)
    needed -= seconds * window.rate
    elapsed += seconds
  }
  return Math.max(0, Math.ceil(elapsed - 1e-7))
}
